import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import {
  accountSelectors,
  apiActions as nucleusApiActions,
  contactSelectors,
  featureSelectors
} from '@lifesize/nucleus';
import contactActions from 'actions/Contact';
import favoriteActions from 'actions/Favorites';
import Favorites from 'components/Favorites/Favorites';
import { routes } from 'constants/Application';

const mapStateToProps = (state) => {
  const favorites = contactSelectors.favoritesSelector(state);
  const numFavorites = favorites.length;
  const isLoaded = true;

  return ({
    favorites,
    hideContacts: _get(accountSelectors.getAccountFeatures(state),'hideContacts', false),
    hideMeetings: _get(accountSelectors.getAccountFeatures(state),'hideMeetings', false),
    hideRooms: _get(accountSelectors.getAccountFeatures(state),'hideRooms', false),
    isLoaded,
    isChatEnabled: featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled,
    isAddVisible: _get(state, 'app.favorites.isAddVisible') ? _get(state, 'app.favorites.isAddVisible') : false,
    numFavorites
  });
};

const mapDispatchToProps = (dispatch, ownProps) =>
  ({
    handleAudioCall: contact =>
      dispatch(contactActions.startAudioCall(contact)),
    handleChat: contact => {
      ownProps.history.push(routes.chat);
      dispatch(contactActions.chatWith(contact));
    },
    handleRemoveAsFavorite: contactId =>
      dispatch(nucleusApiActions.contactSetFavorite(contactId, false)),
    handleVideoCall: contact =>
      dispatch(contactActions.startVideoCall(contact)),
    handleToggleAddFavorites: isVisible =>
      dispatch(favoriteActions.toggleAddFavorite(isVisible))
  });

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Favorites));
